import React, { useEffect, useRef } from "react";
import "./KitchenLocation.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import tzlookup from "tz-lookup";
const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const useLoadGoogleMapsScript = (callback) => {
  useEffect(() => {
    if (!apiKey) {
      console.error("Google Maps API key is not defined.");
      return;
    }
    if (!document.querySelector(`[src*="maps.googleapis.com"]`)) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // Poll until the Places library is available
        const waitForPlaces = () => {
          if (
            window.google &&
            window.google.maps &&
            window.google.maps.places
          ) {
            callback();
          } else {
            setTimeout(waitForPlaces, 100);
          }
        };
        waitForPlaces();
      };
      script.onerror = () => console.error("Error loading Google Maps script.");
      document.head.appendChild(script);
    } else {
      // If script already exists, poll until places is available
      const waitForPlaces = () => {
        if (window.google && window.google.maps && window.google.maps.places) {
          callback();
        } else {
          setTimeout(waitForPlaces, 100);
        }
      };
      waitForPlaces();
    }
  }, [callback, apiKey]);
};

const KitchenLocation = ({ editMode, kitchenData, updateKitchenData }) => {
  const addressInputRef = useRef(null);

  // Compute default coordinates based on the user's timezone.
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const defaultCoordinatesByTimeZone = {
    "America/Los_Angeles": { lat: 34.0522, lng: -118.2437 },
    "America/New_York": { lat: 40.7128, lng: -74.006 },
    "America/Chicago": { lat: 41.8781, lng: -87.6298 },
  };
  const defaultCoordinates = defaultCoordinatesByTimeZone[userTimeZone] || {
    lat: 34.0522,
    lng: -118.2437,
  };

  // Initialize parent's state with default coordinates only once
  useEffect(() => {
    if (kitchenData.latitude == null || kitchenData.longitude == null) {
      updateKitchenData({
        latitude: defaultCoordinates.lat,
        longitude: defaultCoordinates.lng,
      });
    }
  }, [
    kitchenData.latitude,
    kitchenData.longitude,
    defaultCoordinates.lat,
    defaultCoordinates.lng,
    updateKitchenData,
  ]);

  // Load the Google Maps script and initialize autocomplete
  useLoadGoogleMapsScript(() => {
    // Check if the Places library is available
    if (
      window.google &&
      window.google.maps &&
      window.google.maps.places &&
      addressInputRef.current
    ) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        addressInputRef.current,
        { types: ["geocode"], componentRestrictions: { country: "us" } }
      );
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place && place.geometry) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          updateKitchenData({
            address: place.formatted_address,
            latitude: lat,
            longitude: lng,
          });
        }
      });
    } else {
      console.error("Google Maps Places library is not available.");
    }
  });

  // Update the timezone whenever latitude or longitude changes
  useEffect(() => {
    if (kitchenData.latitude && kitchenData.longitude) {
      let tz = "";
      try {
        tz = tzlookup(kitchenData.latitude, kitchenData.longitude);
      } catch (err) {
        console.error("Error determining timezone:", err);
      }
      if (kitchenData.timeZone !== tz) {
        updateKitchenData({ timeZone: tz });
      }
    }
  }, [
    kitchenData.latitude,
    kitchenData.longitude,
    kitchenData.timeZone,
    updateKitchenData,
  ]);

  return (
    <div className="kitchen-location">
      <div className="form-group">
        <label htmlFor="address-input">Address</label>
        <div className="input-with-icon">
          <FaMapMarkerAlt className="input-icon" />
          <input
            type="text"
            id="address-input"
            ref={addressInputRef}
            placeholder="Enter kitchen address"
            value={kitchenData.address || ""}
            onChange={(e) => updateKitchenData({ address: e.target.value })}
          />
        </div>
        <small className="char-limit">
          Note: The exact location will be shared upon booking confirmation.
        </small>
      </div>

      {/* <div className="form-row">
        <div className="form-group">
          <label>Latitude</label>
          <input type="number" value={kitchenData.latitude || ""} readOnly />
        </div>
        <div className="form-group">
          <label>Longitude</label>
          <input type="number" value={kitchenData.longitude || ""} readOnly />
        </div>
      </div> */}
    </div>
  );
};

export default KitchenLocation;
